import React from 'react';
import { Modal, Table, Form, Empty, Input, Button } from 'antd';

import global from '../../../common/utility/global';

const { Search } = Input;

class ImportarModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleSearch = (value) => {
        const dataSource = this.props.dataSource.filter(item => {
            return global
                .formatSearch( `${item.fechaStr} - ${item.nombreTipoComprobante} - ${item.serie}-${item.documento} - ${item.totalStr}`)
                .match(global.formatSearch(value));
        });
        this.props.form.setFieldsValue({ dataSource });
    };

    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        getFieldDecorator('dataSource', { initialValue: this.props.dataSource });
        getFieldDecorator('loading', { initialValue: false });
        return (
            <Modal
                title={this.props.tittle}
                visible={this.props.visible}
                style={{ top: 30 }}
                width="800px"
                onCancel={() => {
                    this.props.form.resetFields();
                    this.props.onClose()
                }}
                footer={[
                    <Button
                        key="send"
                        type="primary"
                        onClick={() => {
                            this.props.form.resetFields();
                            this.props.onClose()
                        }}
                    >
                        Ok
                    </Button>
                ]}
            >
                <Form>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="">
                                {getFieldDecorator('inputSearch', {
                                    initialValue: ''
                                })(
                                    <Search
                                        placeholder="Buscar..."
                                        autoComplete="off"
                                        maxLength={100}
                                        loading={getFieldValue('loading')}
                                        onSearch={value => this.handleSearch(value)}
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <Table
                                size="small"
                                style={{ overflowX: 'auto' }}
                                rowKey={record => record.id}
                                dataSource={getFieldValue('dataSource')}
                                rowClassName='cursor-pointer'
                                onRow={(item,rowIndex) => ({ onClick: () => (this.props.onSelect(item)) })}
                                locale={{
                                    emptyText: <Empty
                                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                                        description="No se encontraron datos."
                                    />
                                }}
                                columns={[
                                    {
                                        title: 'Fecha',
                                        dataIndex: 'fechaStr',
                                        key: 'fechaStr'
                                    },
                                    {
                                        title: 'Cliente',
                                        dataIndex: 'razonSocialCliente',
                                        key: 'razonSocialCliente'
                                    },
                                    {
                                        title: 'Tipo de Comprobante',
                                        dataIndex: 'nombreTipoComprobante',
                                        key: 'nombreTipoComprobante'
                                    },
                                    {
                                        title: 'Serie / Documento',
                                        dataIndex: 'serie',
                                        key: 'serie',
                                        render: (data, row) => (
                                            <span>{row.serie}-{row.documento}</span>
                                        )
                                    },
                                    {
                                        title: 'Total',
                                        dataIndex: 'total',
                                        key: 'total',
                                        align: 'right',
                                        render: (data) => (
                                            <span>{data.toFixed(2)}</span>
                                        )
                                    }
                                ]}
                            />
                        </div>
                    </div>
                </Form>
            </Modal>
        );
    }
}
export default Form.create()(ImportarModal)